import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateFollowupService=async(data)=>{
    try {
        const result = await publicPost(`api/admin/followup_template/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateFollowupService=async(data,id)=>{
    try {
        const result = await put(`api/admin/followup_template/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetFollowupService=async()=>{
    try {
        const result = await get(`api/admin/followup_template/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteFollowupService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/followup_template/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

